import React from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  
  const handleLogout = async () => {
    await authService.logout();
    navigate('/signin-new');
  };
  
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Dashboard</h1>
      <p>Welcome to your dashboard!</p>
      <button 
        onClick={handleLogout}
        style={{
          padding: '0.5rem 1rem',
          background: '#6a3de8',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default Dashboard; 